"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapActiveFragmentsOrIndicatorsToDetails = exports.RenderWarningsFromGraph = exports.RenderWarningsFromGraphAndVizportal = void 0;
const tslib_1 = require("tslib");
/* eslint-disable deprecation/deprecation */
const catalog_core_1 = require("@tableau/catalog-core");
const catalog_messages_1 = require("@tableau/catalog-messages");
const react_1 = tslib_1.__importDefault(require("react"));
const DataQualityStatusChip_1 = require("./DataQualityStatusChip");
const DataQualityType_1 = require("./DataQualityType");
/**
 * @deprecated TFS-1478812
 */
function RenderWarningsFromGraphAndVizportal(props) {
    const upstream = props.upstreamWarnings.map(f => mapFragmentToDetail(f, false, props.urls));
    return react_1.default.createElement(RenderWarnings, Object.assign({}, props, { details: props.anchoredWarnings.concat(upstream) }));
}
exports.RenderWarningsFromGraphAndVizportal = RenderWarningsFromGraphAndVizportal;
/**
 * @deprecated TFS-1478812
 */
function RenderWarningsFromGraph(props) {
    const fragments = props.anchoredDataQualityWarnings;
    const anchored = mapActiveFragmentsOrIndicatorsToDetails(fragments, true, props.urls);
    const upstream = props.upstreamDataQualityWarnings.map(f => mapFragmentToDetail(f, false, props.urls));
    return react_1.default.createElement(RenderWarnings, Object.assign({}, props, { details: anchored.concat(upstream) }));
}
exports.RenderWarningsFromGraph = RenderWarningsFromGraph;
function RenderWarnings(props) {
    if (props.details.length > 0) {
        return react_1.default.createElement(DataQualityStatusChip_1.DataQualityStatusChip, Object.assign({}, props));
    }
    return null;
}
/**
 * @deprecated TFS-1478812
 */
function mapActiveFragmentsOrIndicatorsToDetails(warnings, onContentItem, urls) {
    return (0, catalog_core_1.filterOutNullAndUndefined)(warnings
        .filter(w => w.isActive)
        .map(f => mapFragmentOrIndicatorToDetail(f, onContentItem, urls)));
}
exports.mapActiveFragmentsOrIndicatorsToDetails = mapActiveFragmentsOrIndicatorsToDetails;
function mapFragmentOrIndicatorToDetail(either, onContentItem, urls) {
    if (!either.isActive) {
        return null;
    }
    if ('__typename' in either) {
        return mapFragmentToDetail(either, onContentItem, urls);
    }
    else {
        return mapIndicatorToDetail(either, onContentItem, urls);
    }
}
function mapIndicatorToDetail(indicator, onContentItem, urls) {
    return {
        onContentItem,
        isSevere: indicator.isSevere,
        assetName: indicator.assetName,
        assetType: indicator.assetType,
        assetUrl: urls ? indicator.assetUrl(urls) : undefined,
        author: authorFromIndicator(indicator),
        localizedDate: indicator.updatedAt
            ? catalog_messages_1.Formatters.formatMediumDateTimeWithoutSeconds(new Date(indicator.updatedAt))
            : '',
        type: (0, DataQualityType_1.stringToDataQualityType)(indicator.type),
        message: indicator.message,
    };
}
function mapFragmentToDetail(fragment, onContentItem, urls) {
    return {
        onContentItem,
        assetName: assetName(fragment),
        assetType: assetType(fragment),
        assetUrl: urls ? assetUrl(urls, fragment) : undefined,
        author: authorFromWarning(fragment),
        localizedDate: catalog_messages_1.Formatters.formatMediumDateTimeWithoutSeconds(new Date(fragment.updatedAt)),
        type: (0, DataQualityType_1.stringToDataQualityType)(fragment.warningType),
        message: fragment.message,
        isSevere: fragment.isSevere,
    };
}
function authorFromIndicator(indicator) {
    return {
        name: indicator.owner.displayName,
        username: indicator.owner.username,
        domain: indicator.owner.domainName || null,
    };
}
function authorFromWarning(warning) {
    return {
        name: warning.author && warning.author.name || warning.authorDisplayName,
        username: warning.author && warning.author.username,
        domain: warning.author && warning.author.domain,
    };
}
function assetName(fragment) {
    if (fragment.asset && fragment.asset.name !== null) {
        return fragment.asset.name;
    }
    else {
        return '';
    }
}
function assetType(fragment) {
    if (fragment.asset && fragment.asset.__typename !== null) {
        return fragment.asset.__typename;
    }
    else {
        return null;
    }
}
function assetUrl(urls, fragment) {
    if (!fragment.asset) {
        return '';
    }
    const asset = fragment.asset;
    switch (asset.__typename) {
        case 'Flow':
            return urls.flowUrl(asset.vizportalUrlId);
        case 'PublishedDatasource':
            return urls.datasourceUrl(asset.vizportalUrlId);
        case 'DatabaseServer':
        case 'CloudFile':
        case 'DataCloud':
        case 'File':
        case 'Column':
        case 'WebDataConnector':
            return urls.catalogDatabaseUrl(asset.id);
        case 'VirtualConnectionTable':
        case 'DatabaseTable':
            // case 'CalculatedInsight':
            // case 'DataLake':
            // case 'DataModel':
            return urls.catalogTableUrl(asset.id);
        case 'VirtualConnection':
            return urls.virtualConnectionUrl(asset.id);
        default:
            (0, catalog_core_1.assertUnreachable)(asset);
            return '';
    }
}
//# sourceMappingURL=DataQualityWarningFragments.js.map